import React from 'react';
import { motion } from 'framer-motion';
import { Check, Info, Quote } from 'lucide-react';
export function ProductInfo() {
  return <section className="w-full px-4 py-12 max-w-3xl mx-auto space-y-16" data-id="element-62">
      {/* Product Explanation */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="space-y-6" data-id="element-63">
        <h3 className="font-handwriting text-4xl text-forest font-bold text-center" data-id="element-64">
          Was die Darmflora braucht – und warum Präbiotika der Schlüssel sind
        </h3>

        <p className="font-serif text-lg text-gray-700 text-center mb-8" data-id="element-65">
          Der Unterschied: Probiotika sind lebende Bakterien.{' '}
          <strong className="text-forest" data-id="element-66">Präbiotika</strong> sind die Nahrung,
          die diese nützlichen Bakterien brauchen, um sich im Darm anzusiedeln
          und zu vermehren.
        </p>

        <div className="grid gap-4 md:grid-cols-2" data-id="element-67">
          {[{
          title: 'Inulin',
          desc: 'Nahrung für nützliche Darmbakterien'
        }, {
          title: 'Topinambur',
          desc: 'Natürliches Präbiotikum, fördert Bifidobakterien'
        }, {
          title: 'Mariendistel',
          desc: 'Schützt die Leber während des Wiederaufbaus'
        }, {
          title: 'Leinsamen',
          desc: 'Beruhigt gereizte Darmwände'
        }, {
          title: 'Artischocke',
          desc: 'Unterstützt Verdauungsenzyme'
        }, {
          title: '100% Pflanzlich',
          desc: 'Keine künstlichen Zusätze'
        }].map((item, i) => <div key={i} className="flex items-start gap-3 bg-white/50 p-4 rounded-xl border border-sage" data-id="element-68">
              <div className="mt-1 bg-sage text-forest rounded-full p-1" data-id="element-69">
                <Check size={16} strokeWidth={3} data-id="element-70" />
              </div>
              <div data-id="element-71">
                <h4 className="font-serif font-bold text-forest" data-id="element-72">
                  {item.title}
                </h4>
                <p className="font-serif text-sm text-gray-600" data-id="element-73">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </motion.div>

      {/* Did You Know */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-sage/40 rounded-2xl p-6 md:p-8 border border-sage relative overflow-hidden" data-id="element-74">
        <div className="absolute top-0 right-0 p-4 opacity-10 text-forest" data-id="element-75">
          <Info size={100} data-id="element-76" />
        </div>
        <h3 className="font-handwriting text-3xl text-forest font-bold mb-6 relative z-10" data-id="element-77">
          Wusstest du das?
        </h3>
        <ul className="space-y-4 font-serif text-lg text-gray-800 relative z-10" data-id="element-78">
          <li className="flex items-center gap-3" data-id="element-79">
            <span className="w-2 h-2 rounded-full bg-brown" data-id="element-80"></span>
            70% des Immunsystems sitzen im Darm
          </li>
          <li className="flex items-center gap-3" data-id="element-81">
            <span className="w-2 h-2 rounded-full bg-brown" data-id="element-82"></span>
            Antibiotika zerstören auch nützliche Bakterien
          </li>
          <li className="flex items-center gap-3" data-id="element-83">
            <span className="w-2 h-2 rounded-full bg-brown" data-id="element-84"></span>
            Der Wiederaufbau der Darmflora kann Monate dauern – ohne
            Unterstützung
          </li>
        </ul>
      </motion.div>

      {/* Expert Quote */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center px-4 md:px-12" data-id="element-85">
        <Quote className="mx-auto text-brown/30 mb-4" size={48} data-id="element-86" />
        <p className="font-serif text-xl md:text-2xl italic text-gray-700 leading-relaxed mb-6" data-id="element-87">
          "Nach Antibiotika-Behandlungen ist der Wiederaufbau der Darmflora
          essentiell. Präbiotika wie Inulin und Topinambur liefern die
          Nahrungsgrundlage für nützliche Bakterien und beschleunigen den
          natürlichen Regenerationsprozess."
        </p>
        <p className="font-serif font-bold text-forest text-lg" data-id="element-88">
          – Dr. Nane Schomburg, Tierärztin
        </p>
      </motion.div>
    </section>;
}